import React from "react";
import clsx from "clsx";
import AddButtonNew from '../../AddButton/AddButtonNew';
import NumberSpinner from "../../NumberSpinner/NumberSpinner";

class RoomTypeBuilderOrder extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selected:false
    }
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.amenities_active_tab == 'order',
      'tab-pane': true,
      'card': true
    })

    return (
      <div className={tabClasses} id="order">
        <div className="container pb-0">
          <div className="panel-heading flexed add-button-pannel">
            <div className="col-md-6">
              <h2 className="panel-title mb-0">
                <span className="ss-help help" title={I18n.t("amenity_order_helper_text")}></span>
              </h2>
            </div>            
            
            <div className="col-md-6 flexed add-amenities">
              <AddButtonNew
                model="RentalsUnitedAmenity"
                text={I18n.t('add')}
                buttonClasses="btn btn-primary"
                onAdd={this.props.onAddAmenity}
                generalPosition="left"
                searchInput={true}
                searchFunction={this.searchAmenities}
                ids={this.props.ru_amenity_ids}
              />
            </div>
            </div>
          </div>
        <div className="container">
            {this.renderSelectedAmenities()}
        </div>
      </div>
    );
  };

  renderSelectedAmenities() {
    var self = this

    $(function() {
      $( "#sortable_amenities").sortable({
        handle: ".amenity_handle",
        axis: "y",
        stop: function(event,ui) {
          var idsInOrder = $( "#sortable_amenities" ).sortable("toArray")
          self.props.onChangeAmenityOrder(idsInOrder) 
        }
      });
    });

    var allAmenities = self.props.ru_amenities.sort((a,b) => a.position - b.position).map(roomAmenity => {
      return (
        <div id={roomAmenity.id} key={roomAmenity.id} style={{background: "#efefef", border: "1px solid #dddddd"}}>
          
          <div className='content-div row' style={self.props.onRemove ? { height: '50px' } : null}>
            <div className="amenity-detail col-sm-1">{self.props.read_only ? null : <span className="amenity_handle">&#9776;</span>}</div>
            <div className='amenity-detail col-sm-8'>
              {roomAmenity.name}{roomAmenity.otas && roomAmenity.otas.length > 0 ? <div className="amenity-otas p-0 m-0" style={{display: "contents"}}>({roomAmenity.otas.join(", ")})</div> : ""}: 
            </div>
            <div className="col-sm-2 flexed pull-right">
              <NumberSpinner
                id={roomAmenity.id}
                name="ru_amenity"
                value={roomAmenity.count}
                onChange={self.props.onChange}
                min={1}
                max={999}
              />
            </div>
            {!self.props.read_only ? <div className='ol-remove-btn col-sm-1'><button id={roomAmenity.id} type="button" className="btn btn-secondary" onClick={self.props.onRemoveAmenity}>{I18n.t('remove')}</button></div> : null}
          </div>
        </div>
      )
    })

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="orderable-list" ref="root">      
              <div id='sortable_amenities'>
                {allAmenities.length > 0 ? allAmenities : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
              </div>
          </div>
        </div>
      </div>
    )
  }

  searchAmenities = (dataArray, inputValue) => {
    const unselectedAmenities = dataArray.filter((amenity) => {

    const existingAmenity = this.props.ru_amenities.find(selectedAmenity => amenity.id == selectedAmenity);

      return existingAmenity ? false : true;
    }).sort(function (a, b) {

      const fieldA = a.name.toLowerCase();
      const fieldB = b.name.toLowerCase();

      if (fieldA < fieldB) {
        return -1;
      }
      if (fieldA > fieldB) {
        return 1;
      }

      return 0;
    });

    if (inputValue) {
      const filterObj = unselectedAmenities.filter((dataObj) => dataObj.name.toLowerCase().includes(inputValue.toLowerCase()) );
      const returnObj = filterObj.sort((a, b) => {
        return (this.getSubStringIndex(a.name.toLowerCase(), inputValue) - this.getSubStringIndex(b.name.toLowerCase(), inputValue))
      });
      return returnObj;
    } else {
      return unselectedAmenities;
    };

  };

  getSubStringIndex = (string, substring) => {
    return string.indexOf(substring);
  }; 

};

export default RoomTypeBuilderOrder